<template>
  <kendo-datepicker
    :value="selectedDate"
    :format="'yyyy-MM-dd'"
    style="width: 120px;"
    @change="selectedDateChanged"
  ></kendo-datepicker>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  prop: ['value'],
  data() {
    return {
      selectedDate: null,
    }
  },
  mounted() {
    this.selectedDate = this.reportDate || this.value
    if (this.selectedDate != this.value) {
      this.$emit('input', this.selectedDate)
    }
  },
  computed: {
    ...mapGetters({reportDate: 'app/reportDate'}),
  },
  methods: {
    selectedDateChanged(e) {
      let selectedDate = e.sender.value()
      this.$emit('input', selectedDate)
      this.$store.dispatch('app/changeReportDate', {selectedDate})
    },
  },
}
</script>
